import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import {
  createMigrate,
  FLUSH,
  PAUSE,
  PERSIST,
  PersistedState,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import thunkMiddleware from "redux-thunk";
import reducers from "./reducers";
import { initialState } from "./restaurantsStore";
import AppSagas from "./sagas";

const migrations = {
  0: (state: PersistedState) => {
    // migration clear out device state
    return {
      ...state,
      restaurants: initialState
    };
  }
};

const persistConfig = {
  key: "root",
  version: 0,
  storage,
  blacklist: ["map"],
  migrate: createMigrate(migrations, {
    debug: process.env.NODE_ENV === "development"
  })
};

const persistedReducer = persistReducer(persistConfig, reducers);

const saga = createSagaMiddleware();

const store = configureStore({
  reducer: persistedReducer,
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }),
    saga,
    thunkMiddleware
  ]
});

export let persistor = persistStore(store);

saga.run(AppSagas);

export default store;

export type AppState = ReturnType<typeof reducers>;
